import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Breadcrumb } from "rsuite";
import { Button, Icon } from "../../components";
import { ButtonType } from "../../components/button";
import CustomLoader from "../../components/loader";
import { fileUrl } from "../../redux/base/url";
import { getCarDetailWithView } from "../../redux/cars";
import { CarDetail, Price } from "../../redux/cars/types/carDetail";
import {
  getCarPriceList,
  getRentalConditionList,
} from "../../redux/definitions";
import { RentalConditions } from "../../redux/definitions/types/rentalConditions";
import { getLocalized } from "../../redux/localization";
import { MdIosShare } from "react-icons/md";
import "./style.scss";
import ShareModalDiv from "./share";
import CarCard from "../../components/car-card";
import CreateOfferPage from "../offer";
import ContactModal from "./contactModal";
import moment from "moment";
import { browserName, browserVersion } from "react-device-detect";
import browserID from "browser-id";

import { Helmet } from "react-helmet";

const CarDetailPage = () => {
  const location = useLocation();
  const url = new URLSearchParams(location.search);
  const accept = url.get("accept");
  const dispatch = useDispatch();
  const [car, setCar] = useState<CarDetail>();
  const [rentalConditions, setrentalConditions] = useState<RentalConditions>();
  const localize = useSelector(getLocalized);
  const { id }: { id: string } = useParams();
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [prices, setPrices] = useState<Price[]>([]);
  const [showShare, setShowShare] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const [showContact, setShowContact] = useState(false);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  useEffect(() => {
    setLoader(true);
    dispatch(
      getCarDetailWithView({
        payload: {
          onSuccess: (message, payload) => {
            setCar(payload);
            setLoader(false);
          },
          onError: (message) => {},
        },
        body: {
          CarId: id,
          Browser: `${browserName} ${browserVersion}`,
          BrowserId: browserID(),
        },
      })
    );
    // dispatch(
    //   getCarDetail({
    //     payload: {
    //       onSuccess: (message, payload) => {
    //         setCar(payload);
    //         setLoader(false);

    //         payload.ShowStartingPrice &&
    //           accept === "offer" &&
    //           setShowOffer(true);
    //       },
    //       onError: (message) => {},
    //     },
    //     url: "api/car/" + id,
    //   })
    // );
    dispatch(
      getCarPriceList({
        payload: {
          onSuccess: (message, payload) => {
            setPrices(payload);
          },
          onError: (message) => {},
        },
        url: "/api/car/price/bycarid/" + id,
      })
    );
    dispatch(
      getRentalConditionList({
        payload: {
          onSuccess: (message, payload) => {
            setrentalConditions(payload);
          },
          onError: (message) => {},
        },
        url: "api/setting/rentalconditions/rentalcondition",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    if (accept === "offer" && car) {
      if (car.ShowStartingPrice && prices.length > 0) {
        setShowOffer(true);
      } else {
        setShowContact(true);
      }
    }
  }, [car, prices, location]);
  const specs = car
    ? [
        {
          icon: "gas-station",
          value: car.CarSpecs.FuelType,
          title: localize.getString("fueltype"),
        },
        {
          icon: "gear-lever",
          value: car.CarSpecs.GearType,
          title: localize.getString("geartype"),
        },
        {
          icon: "car",
          value: car.CarSpecs.BodyType,
          title: localize.getString("bodytype"),
        },

        {
          icon: "engine-motor",
          value: `${
            car?.CarSpecs.Enginecc > 0 ? car?.CarSpecs.Enginecc : "-"
          } cc`,
          title: localize.getString("engine"),
        },
        {
          icon: "fuel-burn",
          value:
            (car?.CarSpecs.ConsumptionMin > 0
              ? car?.CarSpecs.ConsumptionMin
              : "-") + " lt/100km",
          title: localize.getString("consumption"),
        },
        {
          icon: "co2",
          value:
            (car?.CarSpecs.CarbonDioxideMin > 0
              ? car?.CarSpecs.CarbonDioxideMin
              : "-") + " g/km",
          title: localize.getString("co2"),
        },
      ]
    : [];
  const AlwaysScrollToBottom = () => {
    const elementRef = useRef(null);
    useEffect(() =>
      //@ts-ignore
      elementRef.current.scrollIntoView()
    );
    return <div ref={elementRef} />;
  };
  return (
    <>
      <Helmet>
        {car && (
          <title>{`${car.CarBrand} ${car.CarModel} ${car.CarVersion} ${car.CarPack} I Oto Plan`}</title>
        )}
      </Helmet>
      <AlwaysScrollToBottom />
      {car && (
        <CreateOfferPage
          car={car}
          show={showOffer}
          onHide={() => setShowOffer(false)}
        />
      )}
      <div className="container mt-3 mb-5">
        {loader && <CustomLoader />}
        <div className="w-100 d-flex justify-content-between my-2">
          <h2 className="header-font">
            <div className="breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item href="/" className="breadCrumbText">
                  {localize.getString("home")}
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/cars" className="breadCrumbText">
                  {localize.getString("allcars")}
                </Breadcrumb.Item>
                <Breadcrumb.Item active className="breadCrumbText">
                  {localize.getString("cardetail")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </h2>
          <Button
            buttonType={ButtonType.new}
            icon={<BsArrowRight />}
            title={"TÜM ARAÇLARI GÖSTER"}
            onClick={() => {
              history.push(`/cars`);
            }}
          />
        </div>

        {car && (
          <div className="w-100 ">
            <h2 className="header-fontColored">ARAÇ</h2>
            <Row className="mt-2">
              <Col md={6}>
                {car?.CarImages && (
                  <img
                    src={fileUrl(car?.CarImages.FrontRightImage)}
                    alt=""
                    width={"100%"}
                    height={"auto"}
                  />
                )}
              </Col>
              <Col md={6}>
                <div className="d-flex w-100 justify-content-between">
                  <span className="detailTitle">
                    {car.CarBrand + " " + car?.CarModel}
                  </span>
                  <ShareModalDiv
                    open={showShare}
                    close={() => setShowShare(false)}
                  />
                  <div
                    className="share-icon"
                    onClick={() => setShowShare(true)}
                  >
                    <MdIosShare size={20} />
                  </div>
                </div>
                <div>
                  <span className="detailSubTitle">
                    {car.CarVersion + " " + car?.CarPack}
                  </span>
                </div>
                <div className="my-3">
                  <p
                    className="detailContent"
                    dangerouslySetInnerHTML={{
                      __html: car?.ShortTitle ? car?.ShortTitle : "",
                    }}
                  />
                  <span
                    className="detailContent"
                    dangerouslySetInnerHTML={{
                      __html: car?.ShortDescription
                        ? car?.ShortDescription
                        : "",
                    }}
                  />
                </div>

                <div className="w-100 d-flex justify-content-end">
                  {car.ShowStartingPrice && prices.length > 0 ? (
                    <div className="detailSubTitle">
                      <div className="detailSubTitle">
                        {localize.getString("monthlyprice")}
                      </div>
                      {localize.formatString(
                        localize.getString("pricestartingfrom"),
                        <span className="carCardFooterPriceText ">
                          {new Intl.NumberFormat("tr-TR", {
                            maximumSignificantDigits: 20,
                          }).format(
                            car?.StartingPrice ? car?.StartingPrice : 0
                          )}{" "}
                          TL
                        </span>
                      )}
                      <Button
                        customClassName="btnTeklifOlustur"
                        style={{
                          width: "max-content",
                          marginBlock: 10,
                          marginInlineEnd: 20,
                          fontSize: 24,
                          fontWeight: 700,
                        }}
                        buttonType={ButtonType.newColored}
                        title={"TEKLİF OLUŞTUR"}
                        onClick={() => {
                          setShowOffer(true);
                        }}
                      />
                    </div>
                  ) : (
                    <div className=" mt-3">
                      <div className="detailSubTitle mb-1 px-1">
                        {localize.getString("forpairprice")}
                      </div>
                      <Button
                        customClassName="btnTeklifTalepEt"
                        style={{
                          width: "max-content",
                          marginBlock: 10,
                          marginInlineEnd: 20,
                          fontSize: 24,
                          fontWeight: 700,
                        }}
                        buttonType={ButtonType.newColored}
                        title={"TEKLİF TALEP ET"}
                        onClick={() => {
                          setShowContact(true);
                        }}
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        )}
        {car && (
          <ContactModal
            name={`${car.CarBrand} ${car.CarModel} ${car.CarVersion} ${car.CarModel}`}
            car={car}
            open={showContact}
            close={() => setShowContact(false)}
          />
        )}
        <div className="w-100">
          <Row className="mt-4  ">
            {specs.map((spec) => (
              <Col md={2} xs={4}>
                {
                  <div className="detailSpecCard d-flex justify-content-center align-items-center ">
                    <Icon icon={spec.icon} size={26} />
                    <div className="" style={{ marginInlineStart: 5 }}>
                      <div className="specTitle">{spec.title}</div>
                      <div className="specSubTitle">{spec.value}</div>
                    </div>
                  </div>
                }
              </Col>
            ))}
          </Row>
        </div>
        <div className="w-100 my-5">
          {rentalConditions && (
            <>
              <div className="mb-3">
                <span
                  className="header-fontColored "
                  dangerouslySetInnerHTML={{
                    __html: rentalConditions?.Title
                      ? rentalConditions.Title
                      : "",
                  }}
                />
              </div>
              <span
                className="detailContent"
                dangerouslySetInnerHTML={{
                  __html: rentalConditions?.Description
                    ? rentalConditions.Description.replace(
                        "[date]",
                        moment(new Date()).format("DD/MM/yyy")
                      )
                    : "",
                }}
              ></span>
            </>
          )}
        </div>

        <div className="header-fontColored text-center ">
          {localize.getString("similarcars")}
        </div>
        <div className="w-100 d-flex justify-content-between flex-wrap mb-5 mt-2">
          {car?.SimilarCars.map((x, i) => (
            <CarCard key={i} data={x.SimilarCar} />
          ))}
        </div>
      </div>
    </>
  );
};
export default CarDetailPage;
